import { FileText, CheckCircle, XCircle, Slash, Edit3 } from "react-feather";

// Turns a Quotation record into HistoryTimeline entries.
//
// Entirely DERIVED from actor columns the record already carries
// (CreatedBy/ApprovedBy/RejectedBy/CancelledBy/LastEditedAfterApprovalBy plus
// their dates) - so this needed no new endpoint, no audit table, and it works
// for quotations created long before anyone asked for a history.
//
// All of these are real `datetime` columns, so every entry sets hasTime: true.
// Do NOT copy that blindly into another builder: several tables in this project
// store actor dates as SQL `date`, and printing a clock time on those invents
// precision that does not exist.
// NOTE: there is deliberately no "Sent to customer" entry. QuotationDetailRecord
// carries no document metadata (only Lines), so it cannot be derived from this
// payload - and inventing one from the status would be a guess. If that event is
// wanted here, the detail response needs the document's CreatedDate/CreatedByName
// and delivery statuses added first.
export const buildQuotationHistory = (quotation) => {
  if (!quotation) return [];

  const entries = [
    {
      key: "created",
      label: "Created",
      at: quotation.createdDate,
      by: quotation.createdByName,
      tone: "neutral",
      icon: FileText,
      hasTime: true,
    },
  ];

  if (quotation.approvedDate) {
    entries.push({
      key: "approved",
      label: "Approved",
      at: quotation.approvedDate,
      by: quotation.approvedByName,
      tone: "success",
      icon: CheckCircle,
      hasTime: true,
    });
  }

  if (quotation.rejectedDate) {
    entries.push({
      key: "rejected",
      label: "Rejected",
      at: quotation.rejectedDate,
      by: quotation.rejectedByName,
      detail: quotation.rejectionReason,
      tone: "danger",
      icon: XCircle,
      hasTime: true,
    });
  }

  // Deliberately its own entry rather than folded into "Approved": editing an
  // already-approved quotation changes what the customer was quoted without a
  // re-approval, which is exactly the thing a reviewer needs to see.
  if (quotation.lastEditedAfterApprovalDate) {
    entries.push({
      key: "edited-after-approval",
      label: "Edited after approval",
      at: quotation.lastEditedAfterApprovalDate,
      by: quotation.lastEditedAfterApprovalByName,
      tone: "warning",
      icon: Edit3,
      hasTime: true,
    });
  }

  if (quotation.cancelledDate) {
    entries.push({
      key: "cancelled",
      label: "Cancelled",
      at: quotation.cancelledDate,
      by: quotation.cancelledByName,
      detail: quotation.cancelReason,
      tone: "danger",
      icon: Slash,
      hasTime: true,
    });
  }

  // Chronological. Every date here is a real datetime, so a plain sort is
  // honest - no midnight collisions to break ties around.
  return entries.sort((a, b) => new Date(a.at) - new Date(b.at));
};
